import { Link } from 'react-router-dom';
import img1 from '../../assets/icons/icon-3.png';
import img2 from '../../assets/icons/icon-4.png';
import img3 from '../../assets/icons/icon-5.png';
import img4 from '../../assets/icons/icon-6.png';
import img5 from '../../assets/icons/icon-7.png';
import img6 from '../../assets/icons/icon-8.png';
import icon from '../../assets/icons/cta.png';

import img from '../../assets/icons/ivory-sec.png';
import { useTranslation } from 'react-i18next';

const TopService = () => {
  const { t } = useTranslation();
  const countries = [
    { name: img6, flag: t('routes.training'), link: '/services/training' },
    { name: img5, flag: t('routes.consulting'), link: '/services/consulting' },

    { name: img4, flag: t('routes.training-kits'), link: 'services/training-kits' },
    { name: img3, flag: t('routes.coaching'), link: '/services/coaching' },
    { name: img2, flag: t('routes.evaluations'), link: '/services/evaluate' },
    { name: img1, flag: t('routes.platforms'), link: '/services/platforms' },

  ];
  return (
    <div className="service row justify-content-lg-between justify-content-center">
      <div className="col-lg-6">

        <img src={img} alt={t('home.ivory-services')} className="img-fluid" />
      </div>
      <div className="service-cards col-lg-6 row justify-content-between ">
        <h2 className='col-12 infographic-services'>{t('home.ivory-services')}</h2>
        {countries.map((country, index) => (
          <Link to={country.link} className="col-lg-4 col-md-6 col-6 " key={index}>
            <img src={country.name} alt={`Service ${index + 1}`} className="img-fluid name" />
            <span className="service-title flag">{country.flag}</span>
          </Link>
        ))}
        <a href='/services/sector' className='cta-btn !flex justify-center gap-2 items-center'>
          <img src={icon} alt='logo-icon' /> {t('home.sector-services')}</a>
      </div>
    </div>
  );
};

export default TopService;